/**
 * Agenda enum values (the "Shared Family Planner" module).
 *
 * The same rule the groceries `enums.ts` states applies here: enum values are
 * English snake_case in both API and DB; the Dutch a person reads lives in the
 * client. `pending` is the value, "Wacht op akkoord" is the label.
 *
 * These live in the module's own file, not the groceries `enums.ts`, so the two
 * modules stay code-independent — a module imports `@familyhub/shared` and
 * platform code only, never another module's internals.
 *
 * The model is deliberately small (docs/AGENDA.md): two timelines — **activities**
 * (what the adults do) and **childcare** (where the child is / who is
 * responsible). There are no activity categories, no general "responsibility"
 * kinds and no parent *unavailability* — a moment either has an event on it or
 * it doesn't; the car is a flag on an activity, not a schedule of its own.
 */
/** External people without accounts — grandparents, babysitter, daycare (docs/AGENDA.md §3). */
export const AGENDA_PERSON_KINDS = ['caregiver', 'child', 'other'];
/**
 * A caregiver is either an account holder (`user`) or an external `person`.
 * Kept as a tagged reference rather than one id column, because the two point
 * at different tables and a user is not a person.
 */
export const AGENDA_PARTICIPANT_KINDS = ['user', 'person'];
/**
 * The agenda tables a client pulls and pushes (its own sync set, disjoint from
 * the groceries `SYNC_TABLES`). The module runs its own sync endpoint over
 * exactly these.
 */
export const AGENDA_SYNC_TABLES = [
    'agenda_people',
    'agenda_activities',
    'agenda_childcare',
];
export function isAgendaSyncTable(value) {
    return AGENDA_SYNC_TABLES.includes(value);
}
//# sourceMappingURL=enums.js.map